// App.js
import React, { useEffect } from 'react'; 
import './App.css';

// 🌍 Contextes globaux (langue, groupe, menus)
import { LanguageProvider } from './context/LanguageContext.js';
import { GroupeProvider } from './context/GroupeContext.js';
import { MenuProvider } from './context/MenuContext.js';

import { ThemeProvider as EmojiThemeProvider } from "./context/ThemeContext.js";

// 🧩 Contenu principal de l’application
import AppContent from './AppContent.js';

const App = () => {
  // 🔎 Effet exécuté au montage de l’app
  // Ici on envoie une requête POST vers /debug de ton backend
  // → permet de tester la connexion entre frontend et backend
  useEffect(() => {
  // ⚠️ En local, on SKIP l'appel /debug pour éviter le CORS Render
  if (window.location.hostname === "localhost") {
    console.log("⏭️ Skip /debug en local pour éviter CORS Render");
    return;
  }

  // 🔥 En production : appel normal
  fetch(process.env.REACT_APP_API + "/debug", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ test: "depuis frontend React" })
  })
    .then(res => res.json())
    .then(data => console.log("🔎 Réponse debug:", data))
    .catch(err => console.error("❌ Erreur debug:", err));
}, []);


   return (
    // 🌐 Fournisseurs de contexte globaux
    // Chaque provider rend ses données accessibles à toute l’app
  <LanguageProvider>
    <GroupeProvider>    {/* Contexte pour le groupe actif */}
      <MenuProvider>
        <EmojiThemeProvider>
          <AppContent />
        </EmojiThemeProvider>
      </MenuProvider>
    </GroupeProvider>
  </LanguageProvider>
);
};

export default App;
